'use es6';

import { CRM_SUITE_PRODUCTS } from 'pricing-pages-lib/utils/productsUtils';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import { BUY_TOUCHLESS } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { hasHigherProductLevelInProductInventorySelector, hasProductInProductInventorySelector } from './ProductInventorySelectors';
import { currentSkuIdForProductSelector } from './ProductsSelectors';
import { purchaseMotionsSelector } from './PurchaseMotionSelectors';
export const canUpgradeToProductLevelSuiteSelector = (reduxState, {
  productLevel
}) => {
  const ownsHigherProductLevel = hasHigherProductLevelInProductInventorySelector(reduxState, {
    productLevel
  });
  const crmSuiteProductsForProductLevel = CRM_SUITE_PRODUCTS[productLevel];
  const ownsAllProductLinesInProductLevel = crmSuiteProductsForProductLevel.every(productLine => hasProductInProductInventorySelector(reduxState, {
    productAttributeFilters: {
      productLine,
      productLevel
    }
  }));
  const starterSkuIds = crmSuiteProductsForProductLevel.map(productLine => currentSkuIdForProductSelector(reduxState, {
    productLine,
    productLevel: STARTER
  }));
  const cannotPurchaseAnyStarterSkusTouchlessly = starterSkuIds.every(skuId => {
    const purchaseMotions = purchaseMotionsSelector(reduxState, {
      skuId
    });
    return !purchaseMotions.includes(BUY_TOUCHLESS);
  });
  return !(ownsHigherProductLevel || ownsAllProductLinesInProductLevel || cannotPurchaseAnyStarterSkusTouchlessly);
};